import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {CheckoutUtil} from '../../checkout/checkout-util';
import {FloatingPresence} from '../common/floating-presence/floating-presence-models';
import {FloatingPresenceParam} from '../common/floating-presence/floating-presence-param-models';
import {GetPwpProfile} from './gql-pwp-profile';

@Injectable({
    providedIn: 'root',
})
export class GqlPwpProfileService {

    constructor(private readonly apollo: Apollo) {}

    getPwpProfile(subdomain: string): Observable<FloatingPresence> {
        return this.apollo
            .watchQuery({query: GetPwpProfile, variables: {subdomain}})
            .valueChanges
            .pipe(
                take(1),
                map((data: any) => {
                    const raw = CheckoutUtil.handleApolloResponse(data, (d: any) => d.data.getPwpProfile);
                    return this.mapToFloatingPresence(raw);
                }),
            );
    }

    private mapToFloatingPresence(raw: any): FloatingPresence {
        const fp = new FloatingPresence();
        fp.subdomain = raw.subdomain;
        fp.country = raw.country;
        fp.websiteId = raw.websiteId;
        if (raw.params) {
            fp.params = {};
            raw.params.forEach((entry: any) => {
                const param = new FloatingPresenceParam();
                param.param = entry.param;
                param.value = entry.value;
                param.visible = entry.visible;
                fp.params[entry.key] = param;
            });
        }
        return fp;
    }
}
